module.exports = ".forgot-pass {\n  font-size: 12px; }\n\n.mouse {\n  cursor: pointer;\n  text-decoration: none; }\n"